module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_03_activity-bbc773924b36d072295cb3365a241efd.jpg";